import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const contractSwitchIcon = (
    <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.5 1L5.5 5H13" stroke="currentColor" strokeWidth="2"/>
        <path d="M1 9.5L4 6.5" stroke="currentColor" strokeWidth="2"/>
        <path d="M10 1.5L13.5 5L10 8.5" stroke="currentColor" strokeWidth="2"/>
    </svg>
)

const Contract: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {contractSwitchIcon}
    </SvgIcon>
)

export default Contract